import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import InputField from "components/Input/InputField";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RestoreClientModal({ open, item, handleCancel, handleDelete }) {
  const [text, setText] = React.useState("");

  return (
    <div>
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleCancel}>
        <DialogTitle className="font-bold uppercase">Restore {item || "item"} ?</DialogTitle>
        <hr />
        <DialogContent>
          <DialogContentText className="text-lg py-3">
            Are you sure want to restore the selected {item || "item"}?
          </DialogContentText>
          Please type RESTORE to confirm.
          <InputField
            type="text"
            placeholder="Enter RESTORE"
            name="delete"
            required
            outerClassName="mt-3"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </DialogContent>
        <hr />
        <DialogActions className="py-2">
          <Button onClick={handleCancel} variant="outlined" color="error">
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            disabled={text !== "RESTORE"}
          >
            RESTORE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
